import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { CustomPanel, CustomTabView, Loading, PageHeader } from '../../../../../../components'
import { TabPanel } from 'primereact/tabview'
import { showMessageBox } from '../../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../../services/util/error.service'
import EstoqueHttp from '../../../../../../services/api/https/estoque/Estoque.http'
import CardsHistoricoLeitura from '../../../../Picking/HistoricoLeitura/CardsHistoricoLeitura'
import TabSeparacaoPorProduto from '../../../../Picking/HistoricoLeitura/TabSeparacaoPorProduto'
import TabHistoricoExpedicao from './TabHistoricoExpedicao'
import TabBipsExcluidosExpedicao from './TabBipsExcluidosExpedicao'
import { normalizeCardInfosTimezone } from '../../../../Picking/HistoricoLeitura/historicoLeitura.helpers'

function HistoricoConferenciaExpedicao({ history, dispatch, selectedTp }) {
  const { selectedMovimentacao } = history.location.state || {}
  const expedicaoId = selectedMovimentacao && selectedMovimentacao.id

  const [bips, setBips] = useState([])
  const [deletedBips, setDeletedBips] = useState([])
  const [cardInfos, setCardsInfo] = useState([])
  const [produtos, setProdutos] = useState([])
  const [finalizadoPorUser, setFinalizadoPorUser] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    isLoading && _getBipHistory()
  }, [isLoading])

  // Helpers
  const _getBipHistory = async () => {
    try {
      if (!expedicaoId) throw new Error('Não existe registros da conferência dessa expedição')
      const { beeps, infos, finalizado_por_user, produtos, deleted_beeps } =
        await EstoqueHttp.getHistoricoConferenciaExpedicao(selectedTp, expedicaoId)
      setBips(beeps || [])
      setDeletedBips(deleted_beeps || [])
      setFinalizadoPorUser(finalizado_por_user)
      setProdutos(produtos || [])
      setCardsInfo(normalizeCardInfosTimezone(infos))
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoading(false)
    }
  }

  // Render
  return (
    <>
      <PageHeader>8.5 - Histórico de Conferência da Expedição</PageHeader>
      <div style={{ marginTop: 20 }} className="p-grid">
        <CustomPanel
          showBtnNovo={true}
          btnLabel={'Atualizar'}
          onNovo={() => setIsLoading(true)}
          onVoltar={history.goBack}
        >
          {isLoading ? (
            <div className="text-center">
              <Loading />
            </div>
          ) : (
            <CustomTabView activeIndex={0}>
              <TabPanel header={'Informações'}>
                <div className="p-grid p-col-12">
                  <CardsHistoricoLeitura
                    cardInfos={cardInfos}
                    finalizadoPorUser={finalizadoPorUser}
                  />
                  <div className="p-col-12">
                    <CustomTabView activeIndex={0}>
                      <TabPanel header={'% Separação Por Produto'}>
                        <TabSeparacaoPorProduto
                          produtos={produtos}
                          pickingStyle={null}
                          showConsolidarLoteValidade={false}
                        />
                      </TabPanel>
                    </CustomTabView>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header={'Histórico'}>
                <TabHistoricoExpedicao bips={bips} />
              </TabPanel>
              <TabPanel header={'Bips Excluídos'}>
                <TabBipsExcluidosExpedicao bips={deletedBips} />
              </TabPanel>
            </CustomTabView>
          )}
        </CustomPanel>
      </div>
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(HistoricoConferenciaExpedicao))
